import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

///////////////////////////////////////////////////////////////////
// Stroller photo load

export const STROLLER_PRODUCT_PHOTO_FETCH_TRIGGER = 'STROLLER_PRODUCT_PHOTO_FETCH_TRIGGER';
export interface StrollerProductPhotoFetchTriggerAction {
    readonly type: typeof STROLLER_PRODUCT_PHOTO_FETCH_TRIGGER;
    readonly strollerSlug: string;
    readonly strollerVariantId?: number;
}
export const STROLLER_PRODUCT_PHOTO_FETCH_REQUEST = 'STROLLER_PRODUCT_PHOTO_FETCH_REQUEST';
export interface StrollerProductPhotoFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLER_PRODUCT_PHOTO_FETCH_REQUEST;
    readonly strollerSlug: string;
    readonly strollerVariantId?: number;
}
export interface StrollerProductPhotoFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        stroller: number;
        strollerPhotos: number[];
        strollerVariants: number[];
    };
}
export const STROLLER_PRODUCT_PHOTO_FETCH_SUCCESS = 'STROLLER_PRODUCT_PHOTO_FETCH_SUCCESS';
export interface StrollerProductPhotoFetchSuccessAction extends APISuccessAction<StrollerProductPhotoFetchNormalizedResponse> {
    readonly type: typeof STROLLER_PRODUCT_PHOTO_FETCH_SUCCESS;
    readonly strollerSlug: string;
    readonly strollerVariantId?: number;
}
export const STROLLER_PRODUCT_PHOTO_FETCH_FAILURE = 'STROLLER_PRODUCT_PHOTO_FETCH_FAILURE';
export interface StrollerProductPhotoFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLER_PRODUCT_PHOTO_FETCH_FAILURE;
    readonly strollerSlug: string;
    readonly strollerVariantId?: number;
}

export const strollerProductPhotoFetchTrigger =
    (strollerSlug: string, strollerVariantId?: number): StrollerProductPhotoFetchTriggerAction => ({
        type: STROLLER_PRODUCT_PHOTO_FETCH_TRIGGER, strollerSlug, strollerVariantId,
    });
export const strollerProductPhotoFetchApi = {
    request: (strollerSlug: string, strollerVariantId?: number): StrollerProductPhotoFetchRequestAction => ({
        type: STROLLER_PRODUCT_PHOTO_FETCH_REQUEST, strollerSlug, strollerVariantId,
    }),
    success: (strollerSlug: string, response: StrollerProductPhotoFetchNormalizedResponse, strollerVariantId?: number): StrollerProductPhotoFetchSuccessAction => ({
        type: STROLLER_PRODUCT_PHOTO_FETCH_SUCCESS, strollerSlug, response, strollerVariantId,
    }),
    failure: (strollerSlug: string, error: any, strollerVariantId?: number): StrollerProductPhotoFetchFailureAction => ({
        type: STROLLER_PRODUCT_PHOTO_FETCH_FAILURE, strollerSlug, error, strollerVariantId,
    }),
};


///////////////////////////////////////////////////////////////////
// Show/Hide/Check thumbs


export const STROLLER_PRODUCT_PHOTO_TOGGLE_THUMBS_TRIGGER = 'STROLLER_PRODUCT_PHOTO_TOGGLE_THUMBS_TRIGGER';

export interface StrollerProductPhotoToggleThumbsTriggerAction extends Action {
    readonly type: typeof STROLLER_PRODUCT_PHOTO_TOGGLE_THUMBS_TRIGGER;
}

export const strollerProductPhotoToggleThumbsTrigger = (): StrollerProductPhotoToggleThumbsTriggerAction => ({
    type: STROLLER_PRODUCT_PHOTO_TOGGLE_THUMBS_TRIGGER,
});

export const STROLLER_PRODUCT_PHOTO_CHECK_HIDE_THUMBS = 'STROLLER_PRODUCT_PHOTO_CHECK_HIDE_THUMBS';

export interface StrollerProductPhotoCheckHideThumbsAction extends Action {
    readonly type: typeof STROLLER_PRODUCT_PHOTO_CHECK_HIDE_THUMBS;
}

export const strollerProductPhotoCheckHideThumbs = (): StrollerProductPhotoCheckHideThumbsAction => ({
    type: STROLLER_PRODUCT_PHOTO_CHECK_HIDE_THUMBS,
});
export const STROLLER_PRODUCT_PHOTO_UPDATE_THUMBS = 'STROLLER_PRODUCT_PHOTO_UPDATE_THUMBS';

export interface StrollerProductPhotoUpdateThumbsAction extends Action {
    readonly type: typeof STROLLER_PRODUCT_PHOTO_UPDATE_THUMBS;
    readonly hide: boolean;
}

export const strollerProductPhotoUpdateThumbs = (hide: boolean): StrollerProductPhotoUpdateThumbsAction => ({
    type: STROLLER_PRODUCT_PHOTO_UPDATE_THUMBS,
    hide,
});
